import { render, staticRenderFns } from "./PsychologistList.vue?vue&type=template&id=15e2fc49&scoped=true&"
import script from "./PsychologistList.vue?vue&type=script&lang=ts&"
export * from "./PsychologistList.vue?vue&type=script&lang=ts&"
import style0 from "./PsychologistList.vue?vue&type=style&index=0&id=15e2fc49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2fc49",
  null
  
)

export default component.exports